import { object, string, null as zNull, type infer as zInfer } from "zod";

export const updateLuminousIntegration = {
  name: "updateLuminousIntegration" as const,
  input: object({
    accessToken: string().optional(),
    apiDomain: string().optional(),
    restockSetting: object({
      locationId: string(),
      warehouseId: string(),
    }).optional(),
  }),
  output: zNull(),
};

export type UpdateLuminousIntegrationInput = zInfer<
  typeof updateLuminousIntegration.input
>;
